import { memo, useId } from 'react';
import classNames from '@/utils/classNames';

export type SpinnerProps = {
  className?: string;
  size?: 'x-small' | 'small' | 'normal' | 'large';
  theme?: 'light' | 'dark';
};

const Spinner = ({
  className,
  size = 'normal',
  theme = 'light',
  ...props
}: SpinnerProps) => {
  const clipPathId = useId();

  return (
    <svg
      className={classNames(
        'animate-spin',
        {
          'size-12': size === 'large',
          'size-8': size === 'normal',
          'size-6': size === 'small',
          'size-4': size === 'x-small',
          'text-greyscale-950': theme === 'light',
          'text-stone-50': theme === 'dark',
        },
        className,
      )}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <foreignObject
          x={-1166.67}
          y={-1166.67}
          width={2333.33}
          height={2333.33}
          transform="matrix(.012 0 0 .012 12 12)"
        >
          <div
            style={{
              background:
                'conic-gradient(from 90deg,var(--color-blue-500) 0deg,var(--color-blue-50) 360deg,var(--color-blue-500) 360deg)',
              height: '100%',
              width: '100%',
              opacity: 1,
            }}
          />
        </foreignObject>
      </g>
      <path
        clipRule="evenodd"
        d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm0-2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.781 9.6a1 1 0 011.12.864A12 12 0 0124 12a1 1 0 11-2 0 9.99 9.99 0 00-.082-1.28 1 1 0 01.863-1.12z"
        fill="var(--color-blue-500)"
      />
      <defs>
        <clipPath id={clipPathId}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm0-2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

Spinner.displayName = 'Spinner';

export default memo(Spinner);
